import axios from "axios";

export default class BusinessCard {
  constructor() {
    this.API_LINK = process.env.VUE_APP_API_LINK;
    // this.API_LINK = 'http://localhost:8016';
  }

  async getDataUser(params) {
    try {
      
      const response= await fetch(`${this.API_LINK}/vcards//public/cards/${params}`,{
        headers: {
          Accept: 'application/json'
        }
      })
      return response.json();
    } catch (error) {
      throw error;
    }
  }
  async getDataUserDowload(params) {
    try {
      const response = await axios({
        method: "get",
        url: `${this.API_LINK}/vcards//public/cards/${params}`,
        headers: {
          Accept: 'text/vcard',
         
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async Dowload(params) {
    try {
      const response = await axios({
        method: "get",
        url: params,
        headers: {
          Accept: 'text/vcard',
         
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  
}
